import { render } from "./Main.vue?vue&type=template&id=b0d7ba42"
const script = {}
script.render = render

export default script